import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
const Bar = styled.section`
    margin-top: 0;
    max-height: 120px;
    width: 90%;
    display: grid;
    grid-template-columns: 40vw 1fr;


    header{
        object-fit: contain;
        display: flex;

        font-size: 24px;
         
        padding-left: 20px;
    }
    @media (max-width: 500px){
        grid-template-columns: repeat(1,1fr);
        
        a{
            font-size: 16px;
        }
        header{
            h1{
                width:100%;
                text-align: center;

            }
            font-size: 20px;
        }

    }


`
const Links = styled.nav`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    width: 90%;
    margin: 0 0.75rem;
    
    a{
        text-decoration: none;
        color: #333;
        background-color: #eee;
        padding: 10px 20px;
        text-align: center;
        margin: 0 12px;

        border-radius: 7px;
        font-size: 1.5rem;

        transition: all 0.3s ease-in;
        &:hover{
            background-color: #65d394;
        }

    }
 

`

const Navbar = () => {
  return (
    <Bar>
        <header>
            <h1>tibetism media</h1>
        </header>
        <Links>
            <Link to='/'>Home</Link>
            <Link to='/gallery'>Gallery</Link>
            <Link to='/contact'>Contact</Link>
        </Links>
    </Bar>
  )
}

export default Navbar